import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { api } from '../api/client';
import type { City } from '../types/api';

const Cities: React.FC = () => {
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [items, setItems] = useState<City[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.cities.list({ limit: 50 }, token)
      .then((r) => setItems(r.items))
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load'))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div style={{ padding: '24px', color: '#9ca3af' }}>Loading cities…</div>;
  if (error) return <div style={{ padding: '24px', color: '#dc2626' }}>{error}</div>;

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
      <h1 style={{ color: '#fff', marginBottom: '16px' }}>Cities</h1>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '12px' }}>
        {items.map((city) => (
          <Link
            key={city.cityId}
            to={`/cities/${city.cityId}`}
            style={{
              display: 'block',
              padding: '16px',
              border: '1px solid #374151',
              borderRadius: '8px',
              backgroundColor: '#1f2937',
              color: '#fff',
              textDecoration: 'none',
            }}
          >
            <strong>{city.name}</strong>
            <div style={{ fontSize: '14px', color: '#9ca3af', marginTop: '4px' }}>
              {city.region}, {city.country}
            </div>
          </Link>
        ))}
      </div>
      {items.length === 0 && <p style={{ color: '#9ca3af' }}>No cities yet.</p>}
    </div>
  );
};

export default Cities;
